import React, { useState } from 'react';
import '../Component/CSS/ControlloOrari.css';
import TabellaTimbrature from '../Component/TabellaTimbrature';
import Select from '../Component/Select';
import { getOut } from '../App';

export default function ControlloOrari() {
    getOut(11);

    const [inizio, setInizio] = useState(0);
    const [fine, setFine] = useState(0);
    const [selezionato, setSelezionato] = useState('');

    const selezione = {
        url: 'Dipendenti',
        Value: 'Dipendente',
        Display: 'Dipendente',
    };

    return (
        <div id='Contenuto'>
            {process.env.REACT_APP_TIPOSITO === 'SVILUPPO' ? (
                <h1 style={{ color: 'red', textDecoration: 'underline' }}>SVILUPPO</h1>
            ) : (
                <h1>Controllo Orari</h1>
            )}

            <div id='ControlloOrari'>
                <div id='Tempi'>
                    <label htmlFor='DataInizio'>Da Quale Data:</label>
                    <sub>Se non compilato rende dal giorno zero</sub>
                    <input
                        type='date'
                        name='DataInizio'
                        onFocus={() => document.getElementById('DataInizio').showPicker()}
                        onChange={(e) => setInizio(parseInt(e.target.valueAsNumber) / 1000)}
                        id='DataInizio'
                    />
                    <label htmlFor='DataFine'>Fino A Quale Data:</label>
                    <input
                        type='date'
                        name='DataFine'
                        onFocus={() => document.getElementById('DataFine').showPicker()}
                        onChange={(e) => setFine(parseInt(e.target.valueAsNumber) / 1000 + 83400)}
                        id='DataFine'
                    />
                    <label htmlFor='UtenteScelto'>Dipendenti</label>
                    <select
                        onChange={(e) => {
                            setSelezionato(e.target.value);
                            document.getElementById('Firme').src =
                                'data:image/png;base64,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';
                        }}
                        id='UtenteScelto'>
                        <Select value={selezione} />
                    </select>
                    <div id='UtenzaScelta'>{selezionato}</div>
                </div>
                <div>
                    <h3>Firma</h3>
                    <img src={require('./Immagini/Void.png')} alt='Firme' id='Firme' />
                </div>

                <label htmlFor='OreTotali'>Ore Totali</label>
                <input type='text' id='OreTotali' readOnly />
                <label htmlFor='StraordinariTotali'>Straordinari Totali</label>
                <input type='text' id='StraordinariTotali' readOnly />
                <hr></hr>
                <div id='Tabelle'>
                    <TabellaTimbrature
                        value={{
                            url: 'TimbratureNuove',
                            Dipendente: selezionato,
                            Inizio: inizio,
                            Fine: fine,
                        }}
                    />
                </div>
                <hr></hr>
            </div>
        </div>
    );
}
